import {inject, Injectable, Pipe, PipeTransform} from '@angular/core';
import {APP_CONFIG} from "../../app.config";

/**
 * Map app key to translation key.
 */
@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'appKeyToTranslationKey',
  standalone: true,
})
export class AppKeyToTranslationKeyPipe implements PipeTransform {
  private appConfig = inject(APP_CONFIG);
  // sticky apps are not part of the configurable carhubApplications list, e.g. "int-vu2" or "at-vu3"
  private static readonly STICKY_APP_PATTERNS: [RegExp, string][] = [
    [/^int-vu2$/i, 'INT_VU2'],
    [/^[a-z]{2}-vu3$/i, 'INT_VU3'],
  ];

  /**
   * Map app key to translation key.
   */
  transform(appKey: string): string {
    const stickyApp = AppKeyToTranslationKeyPipe.STICKY_APP_PATTERNS.find(([pattern]) =>
      pattern.test(appKey),
    );
    if (stickyApp) {
      return stickyApp[1];
    }
    return this.appConfig.carhubApplications?.find((app) => app.value === appKey)
      ?.messageKey ?? appKey;
  }
}
